import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const IEditorGroupsService = ( createDecorator('editorGroupsService'));
export { IEditorGroupsService };
